export default {
  "content": "<path d=\"M.5 44c0-24.3 19.7-44 44-44s44 19.7 44 44-19.7 44-44 44S.5 68.3.5 44z\" fill=\"#000\" fill-opacity=\".05\"/><path d=\"M41.5 55c3.14 0 6.04-1.06 8.36-2.8l8.22 8.22 2.82-2.82-8.22-8.22a13.83 13.83 0 002.8-8.36c0-7.72-6.28-14-14-14s-14 6.28-14 14S33.78 55 41.5 55zm0-24c5.52 0 10 4.48 10 10s-4.48 10-10 10-10-4.48-10-10 4.48-10 10-10z\" fill=\"#000\" fill-opacity=\".3\"/>",
  "attrs": {
    "width": "89",
    "height": "88",
    "viewBox": "0 0 89 88",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};